export default "__VITE_ASSET__257c4d0b__"